import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { first } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ChecklistItem } from '../interface/checklist-model';
import { DataService } from './data.service';
import { firstValueFrom } from 'rxjs';
import { FIREBASE_STORAGE_PATHS } from './fb-image-downloader.service';


@Injectable({
  providedIn: 'root'
})
export class ChecklistModelItemServiceService {

  private _isFromMatrix = false;


  url = `${environment.mkgoURL}/api/v1/checklist-model-item`;

  constructor(
    private _http: HttpClient,
    private dataService: DataService,
    private _storage: AngularFireStorage
  ) { }

  public async create(item: ChecklistItem): Promise<string> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp: {id: string} = await this._http.post(this.url, item.toAPI(), options).pipe(first()).toPromise() as any;
    item._id = resp.id;
    return resp.id;
  }

  /** @todo test */
  public async getAll(filter?: {
    start?: moment.Moment,
    end?: moment.Moment,
    checklistModel?: string,
  }): Promise<ChecklistItem[]> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    if (filter) {
      let params = new HttpParams();
      if (filter.start) {
        params = params.append('start', filter.start.format('YYYY-MM-dd'));
      }
      if (filter.end) {
        params = params.append('end', filter.end.format('YYYY-MM-dd'));
      }
      if (filter.checklistModel) {
        params = params.append('checklistModel', filter.checklistModel);
      }
      options['params'] = params;
    }
    const resp: { checklistModelItems: any[] } = await this._http.get(this.url, options).pipe(first()).toPromise() as any;
    const chItems = resp.checklistModelItems.map(apiItem => new ChecklistItem(apiItem));
    return chItems;
  }

  /** @todo test */
  public async getById(id: string): Promise<ChecklistItem> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const item: any = await this._http.get(`${this.url}/${id}`, options)
      .pipe(first())
      .toPromise();
    return new ChecklistItem(item);
  }

  /** @todo test */
  public async update(item: ChecklistItem): Promise<any> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp: any = await this._http.put(`${this.url}/${item._id}`, item.toAPI(), options)
      .pipe(first())
      .toPromise();
    return resp;
  }

  /** Store the breakdowns image to a OS */
  public async saveBreakdownImage(company: string, os: string, data: Blob): Promise<string> {
    const path = FIREBASE_STORAGE_PATHS.checklistByModelBreakdown({ companyId: company, osId: os });
    await this._storage.upload(path, data);
    const url = await this._storage.ref(path).getDownloadURL().pipe(first()).toPromise();
    return url;
  }

  public async saveSignatureImage(company: string, os: string, data: Blob): Promise<string> {
    const path = FIREBASE_STORAGE_PATHS.checklistByModelSignature({ companyId: company, osId: os });
    await this._storage.upload(path, data);
    const url = await this._storage.ref(path).getDownloadURL().pipe(first()).toPromise();
    return url;
  }

  public async addPhoto(company:string, os: string, index: number, data: Blob): Promise<string> {
    const path = FIREBASE_STORAGE_PATHS.checklistByModelPhoto({ companyId: company, osId: os, index });
    await this._storage.upload(path, data);
    const url = await this._storage.ref(path).getDownloadURL().pipe(first()).toPromise();
    return url;
  }

  public async removePhoto(company: string, os:string, index: number){
    const path = FIREBASE_STORAGE_PATHS.checklistByModelPhoto({ companyId: company, osId: os, index });
    const resp = await this._storage.ref(path).delete().pipe(first()).toPromise();
    return resp;
  }


}
